"use client";

const ComingSoon2 = () => {
  return (
    <main className="relative flex min-h-screen items-center justify-center bg-background px-6">
      {/* Subtle grid / texture */}
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.03)_1px,transparent_1px)] bg-[size:48px_48px] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.04)_1px,transparent_1px)]" />

      <section className="relative z-10 mx-auto max-w-3xl text-center">
        {/* Status */}
        <span className="inline-flex items-center gap-2 rounded-full border border-foreground-200 bg-foreground-50 px-4 py-1 text-sm font-medium text-foreground-600 dark:bg-foreground-950">
          <span className="h-2 w-2 rounded-full bg-primary" />
          Coming soon
        </span>

        {/* Title */}
        <h1 className="mt-6 text-4xl font-semibold tracking-tight text-foreground-950 md:text-6xl">
          A better way to build,
          <br className="hidden sm:block" />
          <span className="text-primary"> launch, and scale</span>
        </h1>

        {/* Copy */}
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
          We’re preparing a thoughtfully designed platform that helps teams move
          faster with clarity and confidence.
        </p>

        {/* Divider */}
        <div className="mx-auto mt-10 h-px w-24 bg-foreground-200" />

        {/* Meta */}
        <p className="mt-6 text-sm text-foreground-400">
          Launching soon · Built with precision
        </p>
      </section>
    </main>
  );
};

export default ComingSoon2;
